import { Loader } from "@bfc-software/pallet";

import LoginCard from "./login-card";
import UserName from "./user-name";
import LocationNamePlate from "./location-name-plate";
import styles from "./waiting-for-redirect.module.css";

interface WaitingForRedirectProps {
  email: string;
  locationName: string;
}

export default function WaitingForRedirect({
  email,
  locationName,
}: WaitingForRedirectProps) {
  return (
    <LoginCard data-testid="waiting-for-redirect">
      <div className={styles.identity}>
        <LocationNamePlate variant="header" name={locationName} />
        <UserName>{email}</UserName>
      </div>
      <Loader className={styles.loading} />
    </LoginCard>
  );
}
